import React from 'react';
import { MonitorSmartphone, Laptop, Smartphone, TabletSmartphone, ServerCog } from 'lucide-react';

const platformIcons = {
  MonitorSmartphone: MonitorSmartphone,
  Laptop: Laptop,
  Smartphone: Smartphone,
  TabletSmartphone: TabletSmartphone,
  ServerCog: ServerCog
};

const platforms = [
  { name: 'Windows', icon: 'MonitorSmartphone', link: '#' },
  { name: 'macOS', icon: 'Laptop', link: '#' },
  {
    name: 'iOS',
    icon: 'Smartphone',
    link: 'https://apps.apple.com/us/iphone/search?term=drivault'
  },
  {
    name: 'Android',
    icon: 'TabletSmartphone',
    link: 'https://play.google.com/store/search?q=drivault&c=apps'
  },
  { name: 'Linux', icon: 'ServerCog', link: '#' }
];

const Platforms = () => {
  return (
    <section className="py-12 bg-white border-y">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">Works Seamlessly Across All Platforms</h3>
          <p className="text-gray-600">One account. All your devices. Perfectly synced.</p>
        </div>
        
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12">
          {platforms.map((platform) => {
            const IconComponent = platformIcons[platform.icon];
            return (
              <a
                key={platform.name}
                href={platform.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center space-y-3 group cursor-pointer"
              >
                <div className="bg-gray-50 group-hover:bg-[#40E095]/10 p-6 rounded-2xl transition-all duration-300 group-hover:shadow-lg group-hover:scale-110">
                  <IconComponent className="text-gray-700 group-hover:text-[#40E095] transition-colors" size={40} />
                </div>
                <span className="text-sm font-medium text-gray-700 group-hover:text-[#40E095] transition-colors">
                  {platform.name}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Platforms;
